// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilterOutlinedSvg from "@fishx/icons-svg/es/asn/FilterOutlined";
import FishxIcon from '../components/FishxIcon';

var FilterOutlined = function FilterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterOutlinedSvg
  }));
};

FilterOutlined.displayName = 'FilterOutlined';
export default React.forwardRef(FilterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilterOutlined.js
// module id = 2776
// module chunks = 0